import { render, staticRenderFns } from "./AffiliateRegistrationSignatures.vue?vue&type=template&id=e0adaafe"
import script from "./AffiliateRegistrationSignatures.vue?vue&type=script&lang=ts"
export * from "./AffiliateRegistrationSignatures.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports